import React from "react";
import { Link } from "gatsby";
import { Accordion, AccordionItem } from '@contentful/f36-components';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import { MARKS, INLINES, BLOCKS } from '@contentful/rich-text-types';

const FAQ = ({ content, data, title, styleId}) => {


        // *********************************** IF THE LINKS DO NOT LOAD ON THE FIRST CLICK REVISE THIS SECTION ***********************************
  // *********************************** FUNCTION TO BUILD URL PATHS ***********************************
  function getEntryWithId(pageId) {


    const matchingIdSuPage = data.allContentfulSuPage.nodes.find(
      (node) => node.contentful_id === pageId
    );
  
    const matchingIdPdf = data.allContentfulPdf.nodes.find(
      (node) => node.contentful_id === pageId
    );

    const matchingIdSuCourse = data.allContentfulSuCourse.nodes.find(
      (node) => node.contentful_id === pageId
    );

    const matchingId = matchingIdPdf || matchingIdSuPage || matchingIdSuCourse;


    if (!matchingId) return;
    const matchingEntry =
      matchingId.pageSlug || matchingId.pdfSlug || matchingId.courseSlug;
    const matchingType = matchingId.__typename;

    const buildUrlPath = (items, slug, type) => {
      // Handle PDF and Course cases first
      if (type === "ContentfulPdf") {
        return `${slug}.pdf`;
      }

      if (type === "ContentfulSuCourse") {
        return `courses/${slug}`;
      }

      // Continue with existing navigation logic
      for (const item of items) {
        if (item.navSlug === slug) {
          return `${item.navSlug}`;
        }
        if (item.navNextLevel) {
          const nextLevelPath = buildUrlPath(item.navNextLevel, slug, type);
          if (nextLevelPath !== "") {
            return `${item.navSlug}/${nextLevelPath}`;
          }
        }
      }

      return "";
    };

    //const urlPath = buildUrlPath(data.allContentfulCrNavGroup.nodes, matchingEntry, matchingType);
    const urlPath = buildUrlPath(data.allContentfulSuNavGroup.nodes, matchingEntry, matchingType );

    return `/${urlPath}`;
  }

    const options = {
        renderText: (text) => {
            return text.split('\n').reduce((children, textSegment, index) => {
                return [...children, index > 0 && <br key={index} />, textSegment];
            }, []);
        },
        renderMark: {
            [MARKS.BOLD]: (text) => <strong className="font-bold">{text}</strong>,
        },
        renderNode: {
            [INLINES.ENTRY_HYPERLINK]: (node, children) => {
                const referencedEntry = getEntryWithId(node.data.target.sys.id);
                return <Link to={`${referencedEntry}`}>{children}</Link>;
            },
            [INLINES.HYPERLINK]: (node, children) => {
                const referencedEntry = node.data.uri;
                return <Link to={`${referencedEntry}`} target="_blank">{children}</Link>;
            },
            [INLINES.EMBEDDED_ENTRY]: (node, children) => {
                const thisSlug = node.data.target.sys.slug;
                return (
                    <>
                        <a href={thisSlug} className="underline">
                            {children}
                        </a>
                    </>
                );
            },
            [BLOCKS.HEADING_2]: (node, children) => {
                return <h2>{children}</h2>;
            },
            [BLOCKS.TABLE]: (node, children) => {
                const getPathname = () => {
                    if (typeof window !== 'undefined') {
                        return window.location.pathname;
                    }
                    return ''; // Default path or server-side equivalent
                };

                const path = getPathname();


                return <table className='other-table'>{children}</table>;
            }
        }
    };



    return (
        <>
        
        <div>
            {/* <div className={content[0].faq[0].title.toLowerCase().replace(/\s+/g, '-')}>  */}
            {/* add style id here too */}

                {/* {(content.faq[0].showName) ? <h2>{content[0].faq[0].title}</h2> : null} */}
                
            
                
               
                <h2>{title}</h2>
                

                {content.map((qa) => (
                    <>
                        <Accordion key={qa.id} id={qa.styleId}>
                            <AccordionItem title={qa.question}> 
                                    <p>{renderRichText(qa.answer, options)}</p>
                            </AccordionItem>
                        </Accordion>
                    </>
                ))
                }
            </div>
        </>
    );
}

export default FAQ;